import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shared/components/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: 'error',
        loadComponent: () => import('./pages/components/error/error.component').then(m => m.ErrorComponent)
      },
      {
        path: '',
        loadComponent: () => import('./pages/components/onboarding/onboarding.component').then(m => m.OnboardingComponent)
      },
      {
        path: ':domain',
        loadComponent: () => import('./pages/components/onboarding/onboarding.component').then(m => m.OnboardingComponent)
      },
      {
        path: ':domain/activation',
        loadComponent: () => import('./pages/components/activation/activation.component').then(m => m.ActivationComponent)
      },
      {
        path: ':domain/contact',
        loadComponent: () => import('./pages/components/activation/contact-form/contact-form.component').then(m => m.ContactFormComponent)
      },
      {
        path: ':domain/success',
        loadComponent: () => import('./pages/components/success/success.component').then(m => m.SuccessComponent)
      },
      {
        path: ':domain/activation-success',
        loadComponent: () => import('./pages/components/activation/activation-success/activation-success.component').then(m => m.ActivationSuccessComponent)
      }
    ]
  }
];